var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSimpleIllustrationAlert = function SvgSimpleIllustrationAlert(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.084 36.81H28.86c.647 0 1.21.053 1.697.145 3.178.61 3.265 2.968 3.265 4.085v5.7H5.278v-5.7c0-1.045.079-3.173 2.686-3.944.575-.169 1.272-.274 2.12-.282v-.004Z",
    fill: "#400000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.004 37.052c-.119-.367 2.41-21.458 2.41-21.458s.808-4.947 9.121-5.145c8.31.202 9.123 5.145 9.123 5.145s2.37 19.765 2.413 21.361a9.51 9.51 0 0 0-1.732-.145h-.245c-.135-2.282-1.974-19.535-1.974-19.535s-.666-4.556-7.482-4.741c-6.82.185-7.481 4.741-7.481 4.741s-1.843 17.257-1.974 19.54c-.863.011-1.577.112-2.163.282l-.012-.04-.004-.005Z",
    fill: "#BF3013"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.09 36.806H10.183c.131-2.282 1.974-19.539 1.974-19.539s.662-4.556 7.482-4.741c6.815.185 7.481 4.741 7.481 4.741s1.843 17.253 1.973 19.535l-.003.004Z",
    fill: "#F25730"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.788 46.737h13.037v-5.701c0-1.117-.087-3.476-3.202-4.085a8.778 8.778 0 0 0-1.664-.145h-9.103",
    stroke: "#002140",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.827 46.737H5.277v-5.701c0-1.045.08-3.174 2.743-3.944.586-.169 1.3-.274 2.163-.282H19.86M8.004 37.052c-.119-.367 2.41-21.458 2.41-21.458s.808-4.947 9.121-5.145c.17 0 .345-.004.523-.004",
    stroke: "#002140",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.067 37.052s.004-.044 0-.1c-.04-1.597-2.413-21.362-2.413-21.362s-.813-4.947-9.122-5.145c-.17 0-.345-.004-.524-.004",
    stroke: "#002140",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m18.129 28.589-5.065 3.19 2.774-5.15-5.183-1.596 5.425-1.472-3.253-5.149 5.302 2.819 1.446-5.274 1.447 5.274 4.941-2.819-2.774 5.028 5.183 1.472-5.183 1.347 3.016 5.273-5.306-3.064-1.324 5.64-1.446-5.519Z",
    fill: "#FFFAF0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M31.867 14.856h6.872M.847 15.344H7.72M19.995 8.05V1.06M27.932 10.09l4.859-4.943M11.336 10.582 6.478 5.64",
    stroke: "#BF3013",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgSimpleIllustrationAlert;